import React from 'react'
import { Link } from 'react-router-dom'

export default function HomeWhat({ ctaText, onCtaClick }) {
    const renderCTA = (link) => {
    const text = ctaText || "Learn More";

    const handleClick = (e) => {
      if (onCtaClick) {
        e.preventDefault();   
        onCtaClick();         
      }
    };

    return (
      <Link to={link} className="arrow-butn" onClick={handleClick}>
        {text} <i className="fa-solid fa-arrow-right"></i>
      </Link>
    );
  };

  return (
    <>
    <section className="home-whatwe">
        <div className="container">
            <div className="row justify-content-center">

                <div className="col-lg-12">
                    <h2 className="heading center-heading">What we do</h2>
                </div>

                <div className="col-lg-5 col-sm-6 col-md-5">
                    <div className="whatwe-box wow animate__animated animate__slideInUp" data-wow-duration="1.3s" data-wow-delay="0.1s">
                        <img src="/assets/images/whatwe-icon-1.webp" alt="Interior Design" loading="lazy"/>
                        <span>Interior Design</span>
                        <p>Shaping spaces with purpose and precision where architecture meets artful, functional, and timeless interior design.</p>
                        {renderCTA("/interior-design-build/")}
                    </div>
                </div>

                <div className="col-lg-5 col-sm-6 col-md-5">
                    <div className="whatwe-box wow animate__animated animate__slideInUp" data-wow-duration="1.3s" data-wow-delay="0.3s">
                        <img src="/assets/images/whatwe-icon-2.webp" alt="Turnkey Execution" loading="lazy"/>
                        <span>Turnkey Execution</span>
                        <p>Delivering end-to-end interior solutions with seamless planning, precision, project management and flawless execution where every detail meets the highest standards.</p>
                        {renderCTA("/turnkey-interior-design-services/")}
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
